@if (_form()) {
  <myre-form [formGroup]="_form()" [elements]="_elements()" />
} @else {
  <myre-dots-loader />
}
